import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectProfile } from '../../state'
import { useNewTranslation } from 'hooks'
import { logout } from '../../state/profile'
import Icon from 'components/Icon/Icon'
import styled from 'particles/themes/styled'
import { NavIconButton } from './styles'
import { StyledButton } from 'components/Shared/Button/NavButton'
import Menu from 'particles/Menu'
import MenuItem from 'particles/MenuItem'
import { StyledBaseMenuItem } from 'particles/MenuItem/style'
import { menuItemClasses } from '@mui/material'
import Text from 'particles/Text'

interface ProfileProps {
    className?: string
    isExtend?: boolean
}

const StyledRoleMenuItem = styled(StyledBaseMenuItem)`
    &.${menuItemClasses.root} {
        display: flex;
        height: 32px;
        padding: 8px 4px;
        align-items: center;
        align-self: stretch;
        &.${menuItemClasses.disabled} {
            opacity: 1;
        }
    }
`

const StyledUserMenuItem = styled(StyledBaseMenuItem)`
    &.${menuItemClasses.root} {
        display: flex;
        width: 164px;
        padding: 8px 4px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: ${({ theme }) => theme.spacing[100]};
        &.${menuItemClasses.disabled} {
            opacity: 1;
        }
    }
`

const Profile: React.FC<ProfileProps> = ({ className, isExtend }) => {
    const [t] = useNewTranslation()
    const profileDetail = useSelector(selectProfile)
    const dispatch = useDispatch()
    const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null)
    const handleOpenMenu = (event: React.MouseEvent<HTMLDivElement>) => {
        setMenuAnchorEl(event.currentTarget)
    }
    const handleCloseMenu = () => {
        setMenuAnchorEl(null)
    }
    const handleLogout = () => {
        dispatch(logout())
    }

    return (
        <div className={className}>
            {isExtend ? (
                <NavIconButton isExtend={true} onClick={handleOpenMenu}>
                    <StyledButton width="100%" height="36px" className="nav-button">
                        <Icon.ProfileIcon width={20} height={20} />
                        <div className="button-name">{t('sidebar.mainMenu.profile')}</div>
                    </StyledButton>
                </NavIconButton>
            ) : (
                <NavIconButton label={t('sidebar.mainMenu.profile')} onClick={handleOpenMenu}>
                    <StyledButton width="36px" height="36px" data-testid="profile-button-not-extend">
                        <Icon.ProfileIcon width={20} height={20} />
                    </StyledButton>
                </NavIconButton>
            )}
            <Menu
                size="s"
                open={Boolean(menuAnchorEl)}
                anchorEl={menuAnchorEl}
                onClose={handleCloseMenu}
                {...(isExtend
                    ? { PaperProps: { sx: { width: 'calc(200% - 1rem)' } } }
                    : {
                          width: 224,
                          transformOrigin: { vertical: 'center', horizontal: 'left' },
                          anchorOrigin: {
                              vertical: 'center',
                              horizontal: 'right',
                          },
                          sx: { marginLeft: '30px' },
                      })}
            >
                <StyledUserMenuItem disabled>
                    <Text scale="bodyS700">{profileDetail.name}</Text>
                    <Text scale="bodyS400" color="secondary">
                        {profileDetail.email}
                    </Text>
                </StyledUserMenuItem>
                <MenuItem.Divider />
                <StyledRoleMenuItem disabled>
                    <Text scale="bodyS400" color="secondary">
                        {t('sidebar.mainMenu.userRole', { roleName: profileDetail.role?.name })}
                    </Text>
                </StyledRoleMenuItem>
                <MenuItem.Divider />
                <MenuItem.Text
                    text={t('sidebar.mainMenu.signOut')}
                    onClick={handleLogout}
                    tabIndex={1}
                    dataTestId={'profile-logout'}
                />
            </Menu>
        </div>
    )
}

export default styled(Profile)`
    margin-bottom: ${({ isExtend }) => (isExtend ? '20px' : 0)};
`
